<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 style="text-align:center;">
        <v-card
          justify="center"
          class="text-center elevation-5 primary"
          style="margin: auto; margin-bottom: 20px;max-width: 700px;padding: 20px; border-radius: 10px;"
        >
          <v-btn fab small color="red" @click="Cancel" style=" float:right">
            <v-icon dark flat style="font-size:25px; color:white; "
              >close</v-icon
            >
          </v-btn>
          <h1 style="color:white; width: fit-content; margin-top: 10px;">
            Add A Post Here:
          </h1>
          <v-form style="margin-top:10px">
            <v-flex>
              <v-text-field
                v-model="title"
                label="*Title"
                single-line
                solo
                required
                style="margin-top:30px"
                v-on:keyup.enter="nothing()"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-autocomplete
                v-model="chosenTags"
                :items="possibleTags.topics"
                solo
                dense
                required
                :counter="maxSelected"
                :counter-value="computedCounterValue"
                chips
                small-chips
                label="*Topic Tags"
                multiple
                :menu-props="menuProps"
                @input="adjustOptions"
              >
                <template slot="selection" slot-scope="data" pa-5>
                  <v-chip
                    text-color="white"
                    :selected="data.selected"
                    close
                    class="chip--select-multi titles"
                    @input="data.parent.selectItem(data.item)"
                  >
                    {{ data.item }}
                  </v-chip>
                </template>

                <template slot="item" slot-scope="data">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex style="padding-bottom: 15px;">
              <v-autocomplete
                v-model="location"
                :items="possibleTags.location"
                cache-items
                flat
                hide-no-data
                hide-details
                label="*Location"
                solo
                dense
                required
              ></v-autocomplete>
            </v-flex>

            <v-flex >
              <v-text-field
              v-for="(qtc, i) in QTC" :key="'qtc' + i"
                v-model="QTC[i]"
                label='*QTC'
                single-line
                solo
                required
                v-on:keyup.enter="nothing()"
              ></v-text-field>
            </v-flex>


            <v-flex>
                <label>Press Enter or Use Commas to Separate Sources</label>
                <v-combobox
                  multiple
                  v-model="commentSources1"
                  clearable
                  :items="commentSources1"
                  label="*Sources"
                  class="link-input"
                  append-icon
                  chips
                  :search-input.sync="commentSources"
                  @keyup.,="linkTabs"
                  @paste="linkTabs"
                  solo
                  deletable-chips
                >
                  <template v-slot:selection="{ index }">
                    <v-chip v-if="index == 0">
                      <v-icon style="font-size:20px; ">add_link</v-icon>
                      &nbsp;{{ commentSources1.length }}
                    </v-chip>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-icon style="font-size:20px; ">cancel</v-icon>
                    <h3
                      style="color: black; width: 100%; padding-left: 5px; white-space: nowrap;"
                    >
                      {{ item }}
                    </h3>
                  </template>
                </v-combobox>
              </v-flex>

            <h3 style="color:white">Add Up To 9 Images In Order</h3>
            <v-flex v-if="this.i <= 8" style="margin-bottom:15px">
              <v-btn
                raised
                class="titles"
                @click="onPickFile"
                style="border-radius: 20px;margin: auto;display: table; margin-top: 10px; color:white"
              >
                <v-icon dark style="font-size:22px; ">publish</v-icon
                >&nbsp;&nbsp;Upload Image
              </v-btn>
              <input
                type="file"
                style="display: none"
                ref="fileInput"
                accept="image/*"
                @change="onFilePicked"
              />
            </v-flex>
            <v-flex style="margin:auto;">
              <v-carousel
                lazy
                style=" margin: auto; border-radius: 10px; max-height:800px; border: 1px white solid;"
                height="100%"
                flat
                hide-delimiters
                :elevation="0"
                :cycle="false"
                v-show="imageUrl.length > 0"
                v-model="imageUrlLength"
              >
                <v-carousel-item
                  flat
                  v-for="(item, j) in this.imageUrl"
                  :key="item"
                  :src="item"
                  height="100%"
                  style="max-height:800px;"
                >
                  <v-btn
                    class="carousel-concord-btn primary"
                    fab
                    small
                    style="color: white; float:right"
                  >
                    {{ j + 1 }}/{{ imageUrl.length }}
                  </v-btn>
                  <v-btn
                    fab
                    small
                    style="color: white; background-color: red; float:left"
                    @click="remove(j)"
                  >
                    <v-icon dark flat style="font-size:28px; color:white; "
                      >delete</v-icon
                    >
                  </v-btn>
                </v-carousel-item>
              </v-carousel>
            </v-flex>

            <v-alert color="red" v-show="verified" style="border-radius: 20px;"
              >PLEASE CHOOSE A NAME, UP TO TWO TAGS, A LOCATION AND AT LEAST ONE
              IMAGE</v-alert
            >
            <v-btn
              @click="storyUpload"
              class="success"
              style="border-radius: 20px;  color:white; margin-top:30px"
            >
              <v-icon dark style="font-size:22px; ">done</v-icon
              >&nbsp;&nbsp;Upload Post
            </v-btn>

            <v-dialog v-model="dialog" width="290" persistent>
              <v-card style="border-radius: 10px">
                <v-card-title class="primary lighten-2" style="color:white">
                  Post Sumbitted
                </v-card-title>

                <v-card-text>
                  Thank You! Add A New Post Or Go Home
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="upvote"
                    class="elevation-4"
                    text
                    @click="(dialog = false), clear()"
                    style="border-radius:20px; color:white"
                  >
                    New Post
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="elevation-4"
                    text
                    @click="(dialog = false), Cancel()"
                    style="border-radius:20px; color:white"
                  >
                    Home
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-form>
        </v-card>

        <template
          v-for="draft in drafts"
          pa-1
          style="  margin: auto; padding: 20px; "
        >
          <div
            :key="draft"
            @click="setDraft(draft)"
            class="elevation-2 chatbackground"
            style="border-radius: 10px; max-width:700px;  padding: 20px; margin:auto; margin-bottom: 8px; "
          >
            <v-card :key="resource" flat pa-1 class="chatbackground">
              <v-btn
                fab
                @click="setDraft(draft)"
                class="secondary elevation-4"
                style="border-radius: 20px; float:right"
              >
                <v-icon dark flat style="font-size:40px; color:white; "
                  >create</v-icon
                >
              </v-btn>
              <p
                class="text-wrap"
                style="font-size: 16px;margin-bottom: 0px;padding-left: 10px;overflow-wrap: break-word;padding-right: 10px;white-space: normal;word-wrap: break-word;width: auto; text-transform: capitalize;"
                pa-1
              >
                {{ draft.title }}
              </p>
              <p
                class="text-wrap"
                style="font-size: 14px;margin-bottom: 0px;padding-left: 10px;overflow-wrap: break-word;padding-right: 10px;display: inline;white-space: normal;word-wrap: break-word;width: auto; text-transform: capitalize; color:red"
                pa-1
              >
                Declined because of {{ draft.chosenReason }}.
                {{ draft.message }}
              </p>

              <v-list class="chatbackground" v-show="draft.tags.length > 0">
                <template v-for="tag in draft.tags">
                  <v-chip
                    :key="tag"
                    class="ma-2 primary elevation-4"
                    style="height:25px;"
                    text-color="white"
                    >{{ tag }}</v-chip
                  >
                </template>
              </v-list>
            </v-card>
          </div>
        </template>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

import firebase from "firebase";
import "firebase/firestore";

export default {
  data() {
    return {
      loading: false,
      editing: false,
      userID: null,
      maxSelected: 2,
      QTC: ['', '', ''],
      imageUrl: [],
      links: "",
      commentSources: "",
      commentSources1: [],
      image: [],
      possibleTags: {
        topics: [
          "Congress",
          "Environment",
          "Education",
          "Supreme Court",
          "Public Health",
          "Public Safety",
          "Military",
          "Economy",
          "International Affairs",
          "Social Justice",
          "Federal Spending",
          "Technology",
          "Entertainment",
          "Human Rights",
          "Litigation",
          "Politics",
        ],
        location: [
          "United States",
          "Alabama",
          "Alaska",
          "American Samoa",
          "Arizona",
          "Arkansas",
          "California",
          "Colorado",
          "Connecticut",
          "Delaware",
          "Washington D.C.",
          "Florida",
          "Georgia",
          "Guam",
          "Hawaii",
          "Idaho",
          "Illinois",
          "Indiana",
          "International",
          "Iowa",
          "Kansas",
          "Kentucky",
          "Louisiana",
          "Maine",
          "Maryland",
          "Massachusetts",
          "Michigan",
          "Minnesota",
          "Mississippi",
          "Missouri",
          "Montana",
          "Nebraska",
          "Nevada",
          "New Hampshire",
          "New Jersey",
          "New Mexico",
          "New York",
          "North Carolina",
          "North Dakota",
          "Northern Mariana Islands",
          "Ohio",
          "Oklahoma",
          "Oregon",
          "Pennsylvania",
          "Puerto Rico",
          "Rhode Island",
          "South Carolina",
          "South Dakota",
          "Tennessee",
          "Texas",
          "U.S. Virgin Islands",
          "Utah",
          "Vermont",
          "Virginia",
          "Washington",
          "West Virginia",
          "Wisconsin",
          "Wyoming",
        ],
      },
      chosenTags: [],
      i: 0,
      title: "",
      menuProps: {
        disabled: false,
      },
      location: "",
      verified: false,
      dialog: false,
      drafts: [],
      imageUrlLength: 0,
    };
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    },
  },
  computed: {
    ...mapState(["user", "userProfile", "userNames"]),
    computedCounterValue() {
      return this.chosenTags.length;
    },
  },
  mounted: function() {
    var self = this;
    setTimeout(function() {
      self.userID = self.userProfile.uid;
    }, 2000);
    // this.getDrafts();
  },
  methods: {
    adjustOptions() {
      if (this.chosenTags.length >= this.maxSelected) {
        this.menuProps.disabled = true;
      } else {
        this.menuProps.disabled = false;
      }
    },
    async setDraft(draft) {
      var self = this;
      this.title = draft.title;
      this.location = draft.tags[draft.tags.length - 1];
      this.chosenTags = [];
      var x = [];
      for (const tag in draft.tags) {
        x.push(draft.tags[tag]);
      }
      this.chosenTags = x;
      this.chosenTags.pop();
      var linkstr = "";
      for (const link in draft.links) {
        linkstr += draft.links[link];
        linkstr += ", ";
      }
      this.links = linkstr;
      this.links = this.links.slice(0, -2);

      //images
      if (draft.items.length == 0) {
        await firebase
          .storage()
          .ref(draft.itemPath)
          .listAll()
          .then(function(res) {
            var arr = [];
            var arr2 = [];

            for (var i = 0; i < res.items.length; i++) {
              arr.push[""];
              arr2.push[""];
            }
            self.imageUrl = arr;
            self.image = arr2;

            res.items.forEach(function(itemRef) {
              var starsRef = firebase.storage().ref(itemRef.fullPath);
              // console.log(starsRef)
              // Get the download URL
              starsRef.getDownloadURL().then(function(url) {
                const index = parseInt(itemRef.name);
                self.imageUrl[index] = url;
                // console.log(url)
                var BASE64_MARKER = ";base64,";
                if (url.indexOf(BASE64_MARKER) == -1) {
                  // var parts = url.split(',');
                  // var contentType = parts[0].split(':')[1];
                  // var raw = decodeURIComponent(parts[1]);
                  // var b = new Blob([raw], {
                  //     type: contentType
                  // });
                  // b.lastModifiedDate = new Date();
                  // b.name = itemRef.name;
                  // self.image[index] = b
                  // var f = new File([b], itemRef.name)
                  // console.log(f)
                } else {
                  // var parts = url.split(BASE64_MARKER);
                  // var contentType = parts[0].split(':')[1];
                  // var raw = window.atob(parts[1]);
                  // var rawLength = raw.length;
                  // var uInt8Array = new Uint8Array(rawLength);
                  // for (var i = 0; i < rawLength; ++i) {
                  //     uInt8Array[i] = raw.charCodeAt(i);
                  // }
                  // var b = new Blob([uInt8Array], {
                  //     type: contentType
                  // });
                  // b.lastModifiedDate = new Date();
                  // b.name = itemRef.name;
                  // self.image[index] = b
                  // var f = new File([b], itemRef.name)
                  // console.log(f)
                }

                self.$forceUpdate();
              });
            });
          });
      }
    },
    async processFile(file) {
      if (!file) {
        return;
      }

      var urls = "";

      // Load the data into an image
      await new Promise(function(resolve) {
        let rawImage = new Image();

        rawImage.addEventListener("load", function() {
          resolve(rawImage);
        });

        rawImage.src = URL.createObjectURL(file);
      }).then(function(rawImage) {
        // Convert image to webp ObjectURL via a canvas blob
        return new Promise(function(resolve) {
          let canvas = document.createElement("canvas");
          let ctx = canvas.getContext("2d");

          canvas.width = rawImage.width;
          canvas.height = rawImage.height;
          ctx.drawImage(rawImage, 0, 0);

          canvas.toBlob(function(blob) {
            resolve(URL.createObjectURL(blob));
            urls = blob
          }, "image/webp");
        });
      });
      return urls;
    },
    querySelections(v) {
      this.loading = true;
      setTimeout(() => {
        this.items = this.possibleTags.location.filter((e) => {
          return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
        });
        this.loading = false;
      }, 500);
    },
    linkTabs() {
      this.$nextTick(() => {
        this.commentSources1.push(this.commentSources.split(",")[0]);
        this.commentSources = "";
      });
    },
    getSources() {
      if (this.commentSources1 != []) {
        const sources = this.commentSources1;

        var i = 0;
        for (i = 0; i < sources.length; i++) {
          var reg = /(www.|http:\/\/|https:\/\/)*/;
          var str = sources[i].replace(reg, "");
          sources[i] = str.trim();
        }
        return sources;
      } else {
        return [];
      }
    },
    onPickFile() {
      if (this.i < 9) {
        this.$refs.fileInput.click();
      }
    },
    async onFilePicked(event) {
      const files = event.target.files;
      let fileName = files[0].name;
      if (fileName.lastIndexOf(".") <= 0) {
        alert("Please add a valid image (.jpg, .png, .webp)");
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imageUrl.push(fileReader.result);
        this.imageUrlLength = this.image.length - 1;
      });
      var url = await this.processFile(files[0]);
      // eslint-disable-next-line no-console
      console.log(url);

      fileReader.readAsDataURL(files[0]);
      this.image.push(url);
      this.i++;
    },
    storyUpload() {
      if (
        this.chosenTags.length > 0 &&
        this.image.length > 0 &&
        this.title != "" &&
        this.location != "" && this.QTC[0] != '' && this.QTC[1] != '' && this.QTC[2] != ''
      ) {

        var arr = this.chosenTags;
        arr.push(this.location);
        if (this.userProfile.isAdmin) {
          this.$store.dispatch("uploadConcordPosts", {
            title: this.title.toLowerCase(),
            files: this.image,
            userID: this.userID,
            sources: this.getSources(),
            tag: arr,
            QTC: this.QTC,
          });
        } else {
          // this.$store.dispatch("uploadUserStory", {
          //   title: this.title.toLowerCase(),
          //   files: this.image,
          //   userID: this.userID,
          //   sources: sources,
          //   tag: arr,
          // });
        }
        this.dialog = true;
      } else {
        //alert
        this.verified = true;
      }
    },
    Cancel() {
      this.$router.push("/news");
    },
    nothing() {
    },
    clear() {
      this.chosenTags = [];
      this.image = [];
      this.title = "";
      this.location = "";
      this.links = "";
      this.imageUrl = [];
    },
    remove(index) {
      if (this.image.length == 1) {
        this.image = [];
        this.imageUrl = [];
      } else {
        this.image.splice(index, 1);
        this.imageUrl.splice(index, 1);
      }
      this.imageUrlLength = 0;
      this.$forceUpdate();
    },
    // async getDrafts() {
    //   var snapshot = await firebase
    //     .firestore()
    //     .collection("userforums")
    //     .where("draft", "==", true)
    //     .where("creatorID", "==", this.userProfile.uid)
    //     .limit(100)
    //     .get();
    //   var d = snapshot.docs.map((doc) => doc.data());
    //   this.drafts = d;
    // },
  },
};
</script>
